import { safetyItems } from "@/mocks/categories";

export default function SafetySection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="bg-foreground-950 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-2/5 relative">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20laptop%20on%20clean%20desk%20showing%20product%20verification%20interface%20with%20authentication%20checkmarks%20fashion%20items%20visible%20on%20second%20screen%20bright%20organized%20workspace%20soft%20warm%20lighting%20professional%20quality%20control%20atmosphere%20light%20sage%20green%20accents%20trustworthy%20and%20premium%20aesthetic%20editorial%20tech%20lifestyle%20photography&width=800&height=900&seq=safety-section-v2&orientation=portrait"
                alt="Superbuy Spreadsheet safety and security"
                className="w-full h-64 lg:h-full object-cover object-top"
                title="Superbuy Spreadsheet Safety Center"
              />
            </div>
            <div className="lg:w-3/5 p-8 md:p-12 lg:p-14 flex flex-col justify-center">
              <span className="text-xs font-semibold uppercase tracking-wider text-background-400 whitespace-nowrap">Safety Center</span>
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mt-3 mb-4">
                Is Superbuy Spreadsheet Safe?
              </h2>
              <p className="text-sm text-background-300 leading-relaxed mb-6 max-w-lg">
                Your safety is our top priority. Learn how to protect yourself while using product research tools, verify information sources, and shop with confidence. Here&apos;s what every <strong className="text-background-100">Superbuy Spreadsheet</strong> user should know.
              </p>

              <div className="space-y-3 mb-6">
                {safetyItems.map((item, idx) => (
                  <div key={idx} className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-600/30 text-primary-300 mt-0.5 shrink-0">
                      <i className="ri-shield-check-line text-xs"></i>
                    </span>
                    <div>
                      <span className="text-sm font-semibold text-background-100 whitespace-nowrap">{item.risk}</span>
                      <span className="mx-2 text-background-500">—</span>
                      <span className="text-sm text-background-300">{item.action}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}